module.exports = __webpack_public_path__ + "img/color_blanco.f697fda3.svg";